
import {
	Card,
	CardBody,
	CardHeader,
	Skeleton,
	Stack,
} from '@chakra-ui/react';

import type { CardRootProps } from '@chakra-ui/react';

export type ProductCardSkeletonProps = CardRootProps;

const ProductCardSkeleton = ({
	aspectRatio = 'square',
	...rest
}: ProductCardSkeletonProps) => {
	return (
		<Card.Root
			borderTopRadius={0}
			cursor={'pointer'}
			p={0}
			{...rest}
		>
			<CardHeader p={0} >
				<Skeleton
					aspectRatio={aspectRatio}
					borderRadius={0}
					width={'100%'}
				/>
			</CardHeader>
			<CardBody p={4}>
				<Stack gap={2} layerStyle={'black'}>
					<Skeleton height={'27px'} width={'40%'} />
					<Skeleton height={'28px'} width={'60%'} />
				</Stack>
			</CardBody>
		</Card.Root>
	);
};

export default ProductCardSkeleton;
